import type { CheckedDownloadItem, CheckedMap, DownloadTreeNode } from '~/types/download'

function normalizeId(id?: string | null) {
  return id?.toLocaleLowerCase?.() ?? null
}

function createCheckedItem(node: DownloadTreeNode): CheckedDownloadItem | null {
  const downloadId = node.downloadId ?? node.id
  if (!downloadId) {
    return null
  }

  return {
    id: downloadId,
    downloadId,
    ezMainNodeId: node.ezMainNodeId,
    tocIndex: node.tocIndex,
    type: node.type,
    payload: node.payload,
  }
}

export function useDownloadItems() {
  const checkedItems = useState<CheckedMap>('download-item', () => new Map())

  function setItem(node: DownloadTreeNode, checked: boolean) {
    const item = createCheckedItem(node)
    if (!item) {
      return
    }
    const key = normalizeId(item.id)
    if (!key) {
      return
    }

    if (checked) {
      checkedItems.value.set(key, item)
    }
    else {
      checkedItems.value.delete(key)
    }
  }

  function onToggleChecked(payload: { item: DownloadTreeNode, checked: boolean }) {
    setItem(payload.item, payload.checked)
  }

  // Used for Mark all / Unmark all functionality in a TOC-subtree
  function onToggleCheckedBulk(payload: { items: DownloadTreeNode[], checked: boolean }) {
    payload.items.forEach(item => setItem(item, payload.checked))
  }

  return {
    checkedItems,
    onToggleChecked,
    onToggleCheckedBulk,
  }
}
